import app, { Component } from 'apprun';
export default class RegionSelectComponent extends Component {

  Options = ({ state }) => <ul>{state.options.map(option =>
    <li class={(option === state.selected) ? 'selected' : ''}
      onclick={() => this.run('select', option)}>{option}
    </li>)
  }
  </ul>

  view = (state) => {
    if (!state.options) {return;}
    return <div class='typeahead'>
      <input id={state.id+'_inpText'} type="text" placeholder="Search:" autocomplete="off" class="form-control"
        value={state.selected}
        $oninput='search'
        $onkeydown='keydown' />
      <div style={state.show?{ display: 'block' }:{ display: 'none' }}><this.Options state={state} /></div>
    </div>;
  }

  update = {

    'search': [async (state, e) => {
      const options = await state.onSearch(e.target.value);
      return {
        ...state,
        show: true,
        selected: e.target.value,
        options
      };
    },  { delay: 300 }],

    'popup': (state, show) => state.show === show ? null : { ...state, show },

    'keydown': (state, e) => {
      let selectedIdx = state.options.indexOf(state.selected);
      switch (e.keyCode) {
      case 27:
        return ({ ...state, show: false });
      case 38:
        selectedIdx--;
        if (selectedIdx < 0) {selectedIdx = 0;}
        return ({ ...state, selected: state.options[selectedIdx] });
      case 40:
        selectedIdx++;
        if (selectedIdx >= state.options.length) {selectedIdx = state.options.length - 1;}
        return ({ ...state, selected: state.options[selectedIdx] });
      case 13:
        e.preventDefault();
        this.run('select', state.selected);
      }
    },
    'select':(state, selected) => {
      state.onSelect(selected);
      return { ...state, selected, show: false };
    }
  }
  mounted = async (props) => {
    return { ...props, options: [], selected: '' };
  };

}
